import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth"; // Importamos el custom hook

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <p>Cargando validación...</p>; // Mientras carga, mostramos un mensaje
  }

  if (!user || user.role_id < 1) {
    // Si no hay usuario o no tiene permisos, redirige al login
    return <Navigate to="/login" replace />;
  }

  return React.cloneElement(children, {user}); // Si el usuario tiene permisos, renderiza la ruta protegida
};

export default PrivateRoute;

